const chunkMapping = {
	"86": [
		70086
	],
	"203": [
		50203
	],
	"339": [
		339
	],
	"483": [
		50483
	],
	"1129": [
		11129
	],
	"1475": [
		31475
	],
	"1855": [
		41855
	],
	"2070": [
		82070
	],
	"2475": [
		82475
	],
	"3006": [
		63006
	],
	"3041": [
		73041
	],
	"3723": [
		33723
	],
	"3855": [
		93855
	],
	"3856": [
		11475
	],
	"3870": [
		93870
	],
	"4403": [
		4403
	],
	"4707": [
		64707
	],
	"4708": [
		94708
	],
	"4792": [
		64792
	],
	"4859": [
		34859
	],
	"5842": [
		15842
	],
	"6006": [
		86006
	],
	"6155": [
		6155
	],
	"6172": [
		86172
	],
	"6351": [
		86351
	],
	"6405": [
		26405
	],
	"6906": [
		96906
	],
	"6969": [
		66969
	],
	"7408": [
		97408
	],
	"7572": [
		27572
	],
	"7605": [
		7605
	],
	"7733": [
		57733
	],
	"7958": [
		67958
	],
	"9083": [
		9083
	],
	"9890": [
		9890
	],
	"9947": [
		19947
	]
};
const idToExternalAndNameMapping = {
	"339": [
		"default",
		"./RollupExceptions",
		71421
	],
	"4403": [
		"default",
		"./ClientDataStoreConfig",
		70083
	],
	"6155": [
		"default",
		"./App",
		4121
	],
	"7605": [
		"default",
		"./DataAuditCompliance",
		70083
	],
	"9083": [
		"default",
		"./App",
		22857
	],
	"9890": [
		"default",
		"./App",
		43441
	],
	"11129": [
		"default",
		"./AttributionRulesPage",
		47517
	],
	"11475": [
		"default",
		"./EnginesModule",
		78595
	],
	"15842": [
		"default",
		"./FormularyConfig",
		71421
	],
	"19947": [
		"default",
		"./DrugChangeReview",
		65377
	],
	"26405": [
		"default",
		"./ClientHierarchy",
		65377
	],
	"27572": [
		"default",
		"./ClientDataOperations",
		70083
	],
	"31475": [
		"default",
		"./StepLibraryTab",
		78595
	],
	"33723": [
		"default",
		"./WhatIfScenarios",
		65377
	],
	"34859": [
		"default",
		"./App",
		74089
	],
	"41855": [
		"default",
		"./CatalogManagement",
		65377
	],
	"50203": [
		"default",
		"./SavingsDashboard",
		47517
	],
	"50483": [
		"default",
		"./SavingsAnalysisDashboard",
		74089
	],
	"57733": [
		"default",
		"./AltPairs",
		65377
	],
	"63006": [
		"default",
		"./Audit",
		65377
	],
	"64707": [
		"default",
		"./DataModule",
		70083
	],
	"64792": [
		"default",
		"./OaRuns",
		74089
	],
	"66969": [
		"default",
		"./AnalyticsApp",
		47517
	],
	"67958": [
		"default",
		"./RulesManagementTab",
		78595
	],
	"70086": [
		"default",
		"./DdidRollupDashboard",
		71421
	],
	"73041": [
		"default",
		"./ChannelDeliveryPage",
		71421
	],
	"82070": [
		"default",
		"./ClientConfig",
		65377
	],
	"82475": [
		"default",
		"./WorkflowsModule",
		78595
	],
	"86006": [
		"default",
		"./MessagesPage",
		71421
	],
	"86172": [
		"default",
		"./PTReviewCycles",
		65377
	],
	"86351": [
		"default",
		"./RankingConfig",
		65377
	],
	"93855": [
		"default",
		"./AnalyticsRulesPage",
		71421
	],
	"93870": [
		"default",
		"./Research",
		65377
	],
	"94708": [
		"default",
		"./App",
		38153
	],
	"96906": [
		"default",
		"./ClaimsConfig",
		71421
	],
	"97408": [
		"default",
		"./App",
		71421
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}